var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"titleComponent"},[_c('h2',{staticClass:"titleComponent__text"},[_c('span',{staticClass:"titleComponent__mainText"},[_vm._v(_vm._s(_vm.data.mainText))]),_vm._v("\n    "+_vm._s(_vm.data.slaveText)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e7ec8a2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/titleComponent.vue
// module id = 220
// module chunks = 0